import { AUTO_LOGIN, ACCESS_TOKEN, REFRESH_TOKEN, MEMBER_ID } from "@/types";

export default function useRemoveTokens(): void {
  // accessToken 삭제
  window.localStorage.removeItem(ACCESS_TOKEN);
  window.sessionStorage.removeItem(ACCESS_TOKEN);
  // refreshToken 삭제
  window.localStorage.removeItem(REFRESH_TOKEN);
  window.sessionStorage.removeItem(REFRESH_TOKEN);

  window.localStorage.removeItem(MEMBER_ID); // member id 삭제
  window.localStorage.removeItem(AUTO_LOGIN); // auto login 삭제
}
